import { jsxs, jsx } from 'react/jsx-runtime';
import AvatarUser from '../../../../user/components/AvatarUser/AvatarUser.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { cssLineClamp, hasHover } from '@fabric-app/ui/constants/styled-utils';
import { styled } from 'styled-components';
import { containerPreviewCompact } from './cssPreviewContainer.js';

const ResourcePreviewPinnedComment = ({ comment }) => {
  return /* @__PURE__ */ jsxs(Wrapper, {
    children: [
      /* @__PURE__ */ jsx(AvatarUser, {
        user: comment.user,
        size: 16
      }),
      /* @__PURE__ */ jsx(Text, {
        children: comment.content
      })
    ]
  });
};
const Text = styled.div.withConfig({
  displayName: "ResourcePreviewComment__Text",
  componentId: "sc-2d8c1f44-0"
})([
  `white-space:nowrap;text-overflow:ellipsis;overflow:hidden;flex-grow:1;font-size:0.75rem;color:`,
  `;word-break:break-word;hyphens:auto;`,
  `;`,
  `{`,
  `;white-space:nowrap;word-break:break-all;}`
], cssVar["color-text-quaternary"], cssLineClamp(2), containerPreviewCompact, cssLineClamp(1));
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewComment__Wrapper",
  componentId: "sc-2d8c1f44-1"
})([
  `display:flex;gap:0.5rem;align-items:center;width:100%;`,
  `{`,
  `:hover{color:`,
  `;}}`
], hasHover, Text, cssVar["color-text-secondary"]);

export { ResourcePreviewPinnedComment };
//# sourceMappingURL=ResourcePreviewComment.js.map
